import { createBrowserRouter } from "react-router-dom";
// // import { BrowserRouter, Routes, Route } from "react-router-dom";

// PAGES

import Error404Page from "../components/error/Error404Page";

import authenticationRoutes from "../components/authentication/routes";
import auditLogsRoutes from "../components/core/audit_logs/routes";
import systemRoutes from "../components/core/system/routes";
import billingRoutes from "../components/core/billing/routes";
import companyRoutes from "../components/core/company_management/routes";
import customerObsessionRoutes from "../components/core/customer_obsession/routes";
import dashboardRoutes from "../components/core/dashboard/routes";
import facilityRoutes from "../components/core/facility_management/routes";
import messageRoutes from "../components/core/messages/routes";
import paymentRoutes from "../components/core/payments/payments.routes";
import powerMeterManagementRoutes from "../components/core/power_meter_management/routes";
import settingRoutes from "../components/core/settings/routes";
import unitRoutes from "../components/core/unit_management/routes";
import waterMeterManagementRoutes from "../components/core/water_management/routes";

export const router = createBrowserRouter([
  ...authenticationRoutes,
  ...dashboardRoutes,
  ...companyRoutes,
  ...facilityRoutes,
  ...unitRoutes,
  ...waterMeterManagementRoutes,
  ...messageRoutes,
  ...settingRoutes,
  ...paymentRoutes,
  ...powerMeterManagementRoutes,
  ...billingRoutes,
  ...customerObsessionRoutes,
  ...auditLogsRoutes,
  ...systemRoutes,
  {
    path: "*",
    element: <Error404Page />,
  },
]);
